// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9d213814","453":"f8d0f6d4","732":"5248f86f","977":"35f079fa"}[chunkId] + ".chunk.js";
};